import * as Sentry from '@sentry/react';

let initialized = false;

export function initSentry() {
  if (initialized) return;
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_ENV || 'development',
    release: import.meta.env.VITE_GIT_COMMIT || undefined,
    tracesSampleRate: import.meta.env.VITE_ENV === 'production' ? 0.05 : 0.1,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
      // Thrown by browser extensions (password managers, form-fillers) that
      // monkey-patch appendChild and JSON.stringify DOM nodes carrying React
      // fibers. Not our code — see stack frames that are entirely <anonymous>.
      'Converting circular structure to JSON',
    ],
    beforeSend: dropInjectedScriptErrors,
  });
  initialized = true;
}

// Drop errors whose stack is composed entirely of injected/eval'd frames with
// no real filename (browser extensions, bookmarklets). Our own bundle always
// resolves to assets/*.js (sourcemapped), never bare "<anonymous>".
export function dropInjectedScriptErrors(event) {
  const frames = event.exception?.values?.[0]?.stacktrace?.frames ?? [];
  const allAnonymous =
    frames.length > 0 &&
    frames.every((f) => !f.filename || f.filename === '<anonymous>');
  return allAnonymous ? null : event;
}

export { Sentry };
